import type { UseFormReturn } from "react-hook-form"

import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"

import { ChoiceField } from "@/components/forms/ChoiceField"
import { RequirementDetailsSection } from "./RequirementDetailsSection"
import { LicenseLogo } from "@/components/common/LicenseLogo"

type BenefitSharingProps = {
  form: UseFormReturn<LicenseData>
}

export const BenefitSharing = ({ form }: BenefitSharingProps) => {
  const strings = useStrings()
  const requiresBenefitSharing = form.watch("benefitSharing") === "yes"

  return (
    <RequirementDetailsSection
      form={form}
      beforeFields={
        <ChoiceField
          form={form}
          name="benefitSharing"
          label={strings.title.benefitSharingPrompt}
          description={strings.question.benefitSharingPrompt}
          behaviour="radio"
          options={[
            {
              title: strings.option.yes,
              description: (strings.affirmation.benefitSharing as string[])[0],
              value: "yes",
              icon: <LicenseLogo logo="benefit-sharing" />
            },
            {
              title: strings.option.no,
              description: (strings.affirmation.benefitSharing as string[])[1],
              value: "no"
            }
          ]}
        />
      }
      fields={[
        ...(requiresBenefitSharing
          ? [
              {
                kind: "text" as const,
                name: "benefitSharingContactEmail",
                label: strings.title.benefitSharingContactEmail,
                description: strings.question.benefitSharingContactEmail,
                inputProps: { type: "email" }
              },
              {
                kind: "text" as const,
                name: "benefitSharingContactUrl",
                label: strings.title.benefitSharingContactUrl,
                description: strings.question.benefitSharingContactUrl,
                inputProps: { type: "url" }
              },
              {
                kind: "textarea" as const,
                name: "benefitSharingActivities",
                label: strings.title.benefitSharingActivities,
                description: strings.question.benefitSharingActivities,
                textareaProps: { rows: 5 }
              }
            ]
          : [])
      ]}
    />
  )
}
